import EmblaCarousel, {
  EmblaCarouselType,
  EmblaOptionsType,
} from 'embla-carousel';

const OPTIONS: EmblaOptionsType = {
  loop: false,
  align: 'start',
  containScroll: 'trimSnaps',
};

function setupPrevNextButtons(
  emblaApi: EmblaCarouselType,
  prevBtn: HTMLButtonElement | null,
  nextBtn: HTMLButtonElement | null,
): void {
  if (prevBtn) prevBtn.addEventListener('click', () => emblaApi.scrollPrev());
  if (nextBtn) nextBtn.addEventListener('click', () => emblaApi.scrollNext());

  const toggleButtons = (): void => {
    if (prevBtn) {
      prevBtn.classList.toggle(
        'embla__button--disabled',
        !emblaApi.canScrollPrev(),
      );
    }
    if (nextBtn) {
      nextBtn.classList.toggle(
        'embla__button--disabled',
        !emblaApi.canScrollNext(),
      );
    }
  };

  emblaApi
    .on('init', toggleButtons)
    .on('select', toggleButtons)
    .on('reInit', toggleButtons);
}

function initCarousel(root: HTMLElement): void {
  const viewport = root.querySelector<HTMLElement>('.embla__viewport');
  if (!viewport) return;

  const emblaApi = EmblaCarousel(viewport, OPTIONS);

  const prevBtn = root.querySelector<HTMLButtonElement>('.embla__button--prev');
  const nextBtn = root.querySelector<HTMLButtonElement>('.embla__button--next');
  setupPrevNextButtons(emblaApi, prevBtn, nextBtn);
}

function init(): void {
  document
    .querySelectorAll<HTMLElement>('.embla')
    .forEach((root) => initCarousel(root));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
